module.exports = __webpack_public_path__ + "static/media/breast-cancer-news.d0efadf2.jpg";